package dev.lingvo.shared.screenshots.geom

import dev.lingvo.shared.screenshots.doc.GroupLayer
import dev.lingvo.shared.screenshots.doc.Layer
import dev.lingvo.shared.screenshots.doc.Page
import dev.lingvo.shared.screenshots.render.Affine

/** Returns the full local-to-strip chain, including groups, so editor handles share the renderer's coordinate space. */
fun worldOf(page: Page, layerId: String): Affine? {
    fun find(layers: List<Layer>, parent: Affine): Affine? {
        for (layer in layers) {
            val world = parent * layer.base.box.toParent()
            if (layer.base.id == layerId) return world
            if (layer is GroupLayer) find(layer.children, world)?.let { return it }
        }
        return null
    }
    return find(page.layers, Affine.IDENTITY)
}
